import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=5034ce07"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5034ce07')) {
      api.createRecord('5034ce07', component.options)
    } else {
      api.reload('5034ce07', component.options)
    }
    module.hot.accept("./EmailList.vue?vue&type=template&id=5034ce07", function () {
      api.rerender('5034ce07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/EmailList.vue"
export default component.exports